var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"inline-block border-t-transparent px-4 cursor-pointer",class:[_vm.activeClasses, _vm.hoverBackgrounds],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }